export default "__VITE_ASSET__Ar9_RC3l__";